module.exports = __webpack_public_path__ + "img/Logo2.e09078e0.png";